export const productTypes = [
  'Hardware',
  'Maintenance',
  'Mix',
  'Professional Service',
  'Software',
  'Service',
  'Warranty',
  'Other',
]

export const productTypesLines = [
  'Hardware',
  'Maintenance',
  'Professional Service',
  'Software',
  'Service',
  'Warranty',
  'Other',
]

export const govPayTerms: string[] = [
  'AOC 30',
  'Credit Card',
  'Due on Receipt',
  'Flooring',
  'Net 15',
  'Net 30',
  'Net 45',
  'Net 60',
  'Prepaid',
  '_CC AP',
]

export const dpasRatingOptions: string[] = [
  'NONE',
  'DX-A1',
  'DX-A2',
  'DX-A3',
  'DX-A4',
  'DX-A5',
  'DX-A6',
  'DX-A7',
  'DX-B1',
  'DX-B8',
  'DX-B9',
  'DX-C1',
  'DX-C2',
  'DX-C3',
  'DX-C9',
  'DX-D1',
  'DX-D2',
  'DX-D3',
  'DX-G1',
  'DX-G2',
  'DX-G3',
  'DX-G4',
  'DX-J1',
  'DX-E1',
  'DX-E2',
  'DX-E3',
  'DX-F1',
  'DX-F2',
  'DX-F3',
  'DX-H1',
  'DX-H5',
  'DX-H6',
  'DX-H7',
  'DX-H8',
  'DX-K1',
  'DX-N1',
  'DX-N2',
  'DX-N3',
  'DX-N4',
  'DX-N5',
  'DX-N6',
  'DX-N7',
  'DX-N8',
  'DO-A1',
  'DO-A2',
  'DO-A3',
  'DO-A4',
  'DO-A5',
  'DO-A6',
  'DO-A7',
  'DO-B1',
  'DO-B8',
  'DO-B9',
  'DO-C1',
  'DO-C2',
  'DO-C3',
  'DO-C9',
  'DO-D1',
  'DO-D2',
  'DO-D3',
  'DO-G1',
  'DO-G2',
  'DO-G3',
  'DO-G4',
  'DO-J1',
  'DO-E1',
  'DO-E2',
  'DO-E3',
  'DO-F1',
  'DO-F2',
  'DO-F3',
  'DO-H1',
  'DO-H5',
  'DO-H6',
  'DO-H7',
  'DO-H8',
  'DO-K1',
  'DO-N1',
  'DO-N2',
  'DO-N3',
  'DO-N4',
  'DO-N5',
  'DO-N6',
  'DO-N7',
  'DO-N8',
]

export const securityRequirementOptions: string[] = ['DD254', 'Other', 'None']

export const setAsides: string[] = [
  'Full & Open',
  'SB (Small Business)',
  'HUBZone (Historically Underutilized Business Zone)',
  'SDVOSB (Service-Disabled Veteran-Owned Small Business)',
  'WOSB (Women-Owned Small Business)',
  '8(a) Business Development Program',
  'SDB (Small Disadvantaged Business)',
]

export const locations: string[] = ['Headquarter', 'Drop Ship', 'KOL - VA', 'KOL -CA', 'Premier - TX']
